import React from 'react';
import { EditorActions } from 'app/stores/editor/actions';
import { useAppDispatch } from 'app/stores/store';
import { Module } from 'app/views/components/editor/text/TextModule';
export const TextEditor = () => {
    const dispatch = useAppDispatch();
    const exitTextEditing = React.useCallback(() => {
        dispatch(EditorActions.setController({
            controller: 'image-annotate',
        }));
    }, [dispatch]);
    React.useEffect(() => {
        const onEscape = (evt) => {
            if (evt.key === 'Escape') {
                exitTextEditing();
                evt.stopImmediatePropagation();
            }
        };
        document.addEventListener('keydown', onEscape, true);
        return () => {
            document.removeEventListener('keydown', onEscape, true);
        };
    }, [exitTextEditing]);
    const onOutsideClick = exitTextEditing;
    const Editor = Module.get('prosemirror');
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                position: 'absolute',
                left: '0px',
                top: '0px',
                width: '100%',
                height: '100%',
                background: 'rgba(0,0,0,0.4)',
            }, onClick: onOutsideClick }),
        React.createElement(Editor, null)));
};
